import React from 'react';

import { RequestButton } from '@common/react/components/Core/LoadingButton/LoadingButton';
import Avatar from '@common/react/components/Forms/Avatar';
import { ListWithTooltip } from '@common/react/components/UI/ListWithTooltip/ListWithTooltip';

import AddUserToSupportChatPopup from '@app/components/Pages/Admin/SupportChats/AddUserToSupportChatPopup';
import { SupportChat, UserWithRemoteId } from '@app/objects/SupportChats';

interface AvatarNodeProps {
	item: UserWithRemoteId;
	chatId: number;
}

const AvatarNode: React.FC<AvatarNodeProps> = (props: AvatarNodeProps) => {
	const { item, chatId } = props;

	return <div className="chat-list__item-avatar chat-list__item-avatar__actions">
		<Avatar
			type=""
			object={{ avatar: item.avatar ? `/remote/${item.avatar}` : '' }}
			readonly
			className="avatar-container"
			showOpenIcon={false}
			showDownload={false}
			withModal={false}
			firstName={item.firstName}
			lastName={item.lastName}
		/>
		<RequestButton
			requestType="supportChatUser"
			requestProps={{
				chatId,
				userId: item.remoteId,
				deleted: true,
			}}
			className="btn btn-default btn-close"
			type="button"
		>
			<i className="fa fa-times" />
		</RequestButton>
	</div>;
};

interface SupportChatUsersSettingsProps {
	currentSupportChat: SupportChat;
	getPatientId: (portalId: number) => void;
}

const SupportChatUsersSettings: React.FC<SupportChatUsersSettingsProps> = (props: SupportChatUsersSettingsProps) => {
	const { currentSupportChat, getPatientId } = props;

	return (
		<>
			<AddUserToSupportChatPopup
				chat={currentSupportChat}
				render={(show) => (
					<button
						className="btn btn-sm btn-info pull-right"
						title="Add user to chat"
						onClick={show}
						type="button"
					>
						<i className="fa fa-plus" style={{ width: 'unset', height: 'unset', lineHeight: 'unset' }} />
					</button>
				)}
				getPatientId={getPatientId}
				autocompleteParams={{
					support: true,
					excludeUserIds: currentSupportChat.contacts
						.filter((user) => user.remoteId && user.remoteId > 0)
						.map((user) => user.remoteId),
				}}
			/>
			<div className="chat-component__actions__users pull-right">
				<ListWithTooltip
					array={currentSupportChat.contacts.filter((user) => user.remoteId && user.remoteId > 0)}
					customNode={(item) => <AvatarNode item={item} chatId={currentSupportChat.id} />}
					count={8}
				/>
			</div>
		</>
	);
};

export default SupportChatUsersSettings;
